export class Storage {
  static getString(key: string) {
    return localStorage.getItem(key);
  }

  static delete(key: string) {
    localStorage.removeItem(key);
  }

  static setString(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static getCurrentUserToken(): string | null | undefined {
    const userString = Storage.getString("currentUser");
    const user = userString ? JSON.parse(userString) : null;
    return user?.accessToken;
  }

  static setBoolean(key: string, value: boolean) {
    localStorage.setItem(key, value.toString());
  }

  static getBoolean(key: string) {
    return localStorage.getItem(key) === "true";
  }
}
